import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IAIAgentTemplate } from '../../extViewmodels/sdk/models/AI';

export function useSetAIAgentTemplateActiveMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (result: IAIAgentTemplate) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({
			id,
			isActive,
			impersonationContext,
		}: {
			id: string;
			isActive: boolean;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<IAIAgentTemplate>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: `aiagenttemplate/${id}/active` }),
				'POST',
				{ isActive }
			);
		},
		onError,
		onSuccess,
	});
}
